export class ListRepositoryAssetsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "assets",
            "baseName": "assets",
            "type": "Array<RepositoryAsset>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListRepositoryAssetsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
